import {Map, fromJS, List} from "immutable";

import {
    FETCH_CLIENTS_REQUEST, FETCH_CLIENTS_SUCCESS, FETCH_CLIENTS_ERROR,
    CREATE_CLIENT_REQUEST, CREATE_CLIENT_SUCCESS, CREATE_CLIENT_ERROR,
    UPDATE_CLIENT_REQUEST, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_ERROR,
    UPDATE_CLIENT_STATUS_REQUEST, UPDATE_CLIENT_STATUS_SUCCESS, UPDATE_CLIENT_STATUS_ERROR,
    DELETE_CLIENT_REQUEST, DELETE_CLIENT_SUCCESS, DELETE_CLIENT_ERROR
} from "./clients-actions";

const clients = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false,
    created: false,
    updated: false,
    deleted: false
}), action) => {
    let newState;
    let updatedPayload, index, payload = state.get("payload");
    switch (action.type) {

        // Requests
        case FETCH_CLIENTS_REQUEST:
        case CREATE_CLIENT_REQUEST:
        case UPDATE_CLIENT_REQUEST:
        case UPDATE_CLIENT_STATUS_REQUEST:
        case DELETE_CLIENT_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false,
                created: false,
                updated: false,
                deleted: false
            });
            return newState;

        // Success
        case FETCH_CLIENTS_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false,
                created: false,
                updated: false,
                deleted: false
            });
            return newState;

        case CREATE_CLIENT_SUCCESS:
            if (List.isList(state.get("payload"))) {
                let updatedPayload = state.get("payload");
                updatedPayload = updatedPayload.push(fromJS(action.payload));

                newState = state.merge({
                    payload: updatedPayload,
                    isFetching: false,
                    error: false,
                    created: action.payload._id,
                    updated: false,
                    deleted: false
                });
            } else {
                newState = state.merge({
                    payload: fromJS(action.payload),
                    isFetching: false,
                    error: false,
                    created: action.payload._id,
                    updated: false,
                    deleted: false
                });
            }
            return newState;

        case UPDATE_CLIENT_SUCCESS:
        case UPDATE_CLIENT_STATUS_SUCCESS:

            // let updatedPayload, index, payload = state.get("payload");

            // Check if payload is a List
            if (List.isList(state.get("payload"))) {

                // Find the index of the customer to be updated inside the List
                index = payload.findIndex(item => {
                    return item.get('_id') === action.payload._id;
                });

                // Update the payload list
                if (index !== -1) {
                    updatedPayload = payload.update(index, () => {
                       return fromJS(action.payload);
                    });
                }

                // If payload is a Map the payload to be updated is action.payload itself
            } else {
                updatedPayload = fromJS(action.payload);
            }
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                payload: updatedPayload,
                created: false,
                updated: action.payload._id,
                deleted: false
            });
            return newState;

        case DELETE_CLIENT_SUCCESS:

            updatedPayload = state.get('payload').filter( client => {
                return client.get('_id') !== action.payload._id;
            });
            newState = state.merge({
                payload: updatedPayload,
                isFetching: action.isFetching,
                error: action.error,
                created: false,
                updated: false,
                deleted: action.payload._id
            });
            return newState;

        // Errors
        case FETCH_CLIENTS_ERROR:
        case CREATE_CLIENT_ERROR:
        case UPDATE_CLIENT_ERROR:
        case UPDATE_CLIENT_STATUS_ERROR:
        case DELETE_CLIENT_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage,
                created: false,
                updated: false,
                deleted: false
            });
            return newState;
        default:
            return state;
    }
};

export default clients;